import React from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';
import './ChipInput.css';

const ChipInput = ({
  label,
  values = [],
  onChange,
  error,
  helperText,
  suggestions = [],
  required = false,
  onInputChange,
}) => {
  return (
    <Autocomplete
      multiple
      freeSolo
      options={suggestions}
      value={values}
      onChange={(e, newValue) => onChange(newValue)}
      onInputChange={(event, newInputValue) => {
        if (onInputChange) {
          onInputChange(newInputValue);
        }
      }}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          const { key, ...rest } = getTagProps({ index });
          return (
            <Chip
              key={key}
              variant="outlined"
              label={option}
              className="chip-item"
              {...rest}
            />
          );
        })
      }
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={required ? `${label} *` : label}
          error={!!error}
          helperText={helperText}
          fullWidth
        />
      )}
      className="chip-input-autocomplete"
    />
  );
};

export default ChipInput;
